function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from "../button";
import SelectInput from "../select-input";
import AddNewBox from "./add-new-box";

var SelectInputWithAddNew =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectInputWithAddNew, _Component);

  function SelectInputWithAddNew() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectInputWithAddNew);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectInputWithAddNew)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: _this.props.defaultExpanded,
      newOption: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddNewClick", function (event) {
      event.preventDefault();
      var expanded = _this.state.expanded;

      _this.setState({
        expanded: !expanded
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddCancel", function () {
      _this.setState({
        expanded: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddSave", function (formValues) {
      var _this$props = _this.props,
          mapValuesToOption = _this$props.mapValuesToOption,
          onChange = _this$props.onChange,
          onSave = _this$props.onSave;

      if (onSave) {
        onSave(formValues);

        _this.setState({
          expanded: false
        });
      } else {
        var newOption = mapValuesToOption(formValues);

        _this.setState({
          expanded: false,
          newOption: newOption
        }, function () {
          return onChange(newOption.value);
        });
      }
    });

    return _this;
  }

  _createClass(SelectInputWithAddNew, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          addButtonText = _this$props2.addButtonText,
          cancelButtonText = _this$props2.cancelButtonText,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          inputProps = _this$props2.inputProps,
          name = _this$props2.name,
          options = _this$props2.options,
          value = _this$props2.value,
          onChange = _this$props2.onChange,
          placeholder = _this$props2.placeholder,
          saveButtonText = _this$props2.saveButtonText,
          inputId = _this$props2.inputId,
          qaid = _this$props2.qaid;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          newOption = _this$state.newOption;
      return React.createElement("div", {
        id: qaid
      }, React.createElement("span", {
        className: "SelectInputWithAddNew-container"
      }, React.createElement(SelectInput, {
        className: "SelectInputWithAddNew-dropdown",
        disabled: disabled,
        inputProps: inputProps,
        options: newOption ? [newOption].concat(_toConsumableArray(options)) : options,
        placeholder: placeholder,
        onChange: onChange,
        value: value
      }), React.createElement(Button, {
        className: "SelectInputWithAddNew-add-button",
        disabled: disabled,
        type: "button",
        onClick: this.handleAddNewClick,
        variant: "link"
      }, ' ', "+", addButtonText), expanded ? React.createElement(AddNewBox, {
        name: name,
        saveButtonText: saveButtonText,
        cancelButtonText: cancelButtonText,
        fields: children,
        onCancel: this.handleAddCancel,
        onSave: this.handleAddSave,
        inputId: inputId
      }) : null));
    }
  }]);

  return SelectInputWithAddNew;
}(Component);

_defineProperty(SelectInputWithAddNew, "propTypes", {
  addButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  // inputs for the add new box
  defaultExpanded: PropTypes.bool,
  // expand the "add" form on first render, default false
  disabled: PropTypes.bool,
  inputProps: PropTypes.object,
  // maps a new set of form values to { label, value }
  inputId: PropTypes.string,
  mapValuesToOption: PropTypes.func,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })),
  placeholder: PropTypes.string,
  saveButtonText: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  qaid: PropTypes.string
});

_defineProperty(SelectInputWithAddNew, "defaultProps", {
  defaultExpanded: false,
  disabled: false,
  options: [],
  placeholder: ''
});

export { SelectInputWithAddNew as default };